import React, { ReactElement, useState } from 'react'
import trackClickEvent from '../../helpers/analytics-utils/track-event'
import { categories, actions } from '../../helpers/analytics-utils/constants'
import FiltersLarge from './filters-large'
import FiltersSmall from './filters-small'
import styles from './index.module.scss'

interface WrapperProps {
  children: ReactElement
  count: number
}

const Wrapper = ({ children, count }: WrapperProps): JSX.Element => {
  const [expanded, expand] = useState(false)
  const formattedCountDisplay = String(count)
  const clickHandle = (): void => {
    expand(!expanded)
    trackClickEvent(
      categories.WHATS_HAPPENING_FILTERS,
      expanded ? actions.COLLAPSE_FILTERS : actions.EXPAND_FILTERS,
      undefined
    )
  }

  return (
    <div className={styles.evolved}>
      <FiltersLarge countDisplay={formattedCountDisplay}>
        {children}
      </FiltersLarge>
      <FiltersSmall countDisplay={formattedCountDisplay} onClick={clickHandle}>
        {children}
      </FiltersSmall>
    </div>
  )
}

export default Wrapper
